"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SectionArrows = /*#__PURE__*/function () {
  function SectionArrows(container) {
    var _this = this;
    var topBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, SectionArrows);
    this.container = $(container);
    this.topBottom = topBottom;
    this.positionElement = null;
    var RESIZE_COMPLETE_DELAY = 250;

    // config values for responsive
    this.config = {
      arrowBaseWidth: 120,
      arrowBaseHeight: 34,
      arrowScaleDesktop: 0.8,
      arrowScaleTablet: 0.6,
      arrowScaleMobile: 0.4
    };

    // redraw on viewport update
    var resizeCompleteTimeout;
    $(window).resize(function () {
      _this.container.removeClass('animated');
      _this.update();
      // disable animation during resize
      if (resizeCompleteTimeout) {
        clearTimeout(resizeCompleteTimeout);
      }
      resizeCompleteTimeout = setTimeout(function () {
        _this.container.addClass('animated');
      }, RESIZE_COMPLETE_DELAY);
    });
  }

  /*
   * Draw the clipping path with arrows
   */
  return _createClass(SectionArrows, [{
    key: "setPosition",
    value: function setPosition(posLeft) {
      var boxHeight = this.container.height();
      var arrWidth = this.config.arrowBaseWidth;
      var arrHeight = this.config.arrowBaseHeight;

      // responsive scale of arrow
      if (Gridle.isActive('desktop')) {
        arrWidth = Math.round(this.config.arrowBaseWidth * this.config.arrowScaleDesktop);
        arrHeight = Math.round(this.config.arrowBaseHeight * this.config.arrowScaleDesktop);
      } else if (Gridle.isActive('tablet')) {
        arrWidth = Math.round(this.config.arrowBaseWidth * this.config.arrowScaleTablet);
        arrHeight = Math.round(this.config.arrowBaseHeight * this.config.arrowScaleTablet);
      } else if (Gridle.isActive('mobile')) {
        arrWidth = Math.round(this.config.arrowBaseWidth * this.config.arrowScaleMobile);
        arrHeight = Math.round(this.config.arrowBaseHeight * this.config.arrowScaleMobile);
      }

      // coordinates for top arrow
      var points = [['0%', '0%'], [posLeft - arrWidth / 2 + 'px', '0%'], [posLeft + 'px', arrHeight + 'px'], [posLeft + arrWidth / 2 + 'px', '0%'], ['100%', '0%'], ['100%', boxHeight + 'px'], ['0%', boxHeight + 'px']];
      // coordinates for top+bottom arrow
      if (this.topBottom) {
        points = [['0%', '0%'], [posLeft - arrWidth / 2 + 'px', '0%'], [posLeft + 'px', arrHeight + 'px'], [posLeft + arrWidth / 2 + 'px', '0%'], ['100%', '0%'], ['100%', boxHeight - arrHeight + 'px'], [posLeft + arrWidth / 2 + 'px', boxHeight - arrHeight + 'px'], [posLeft + 'px', boxHeight + 'px'], [posLeft - arrWidth / 2 + 'px', boxHeight - arrHeight + 'px'], ['0%', boxHeight - arrHeight + 'px']];
      }

      // convert to string for CSS
      var pointArrayStr = '';
      points.forEach(function (point, index) {
        pointArrayStr += point[0] + ' ' + point[1] + (index < points.length - 1 ? ',' : '');
      });

      // apply CSS
      this.container.css({
        'clip-path': 'polygon(' + pointArrayStr + ')',
        '-webkit-clip-path': 'polygon(' + pointArrayStr + ')'
      });
    }

    /*
     * Redraw arrow for positioned element
     */
  }, {
    key: "update",
    value: function update() {
      if (this.positionElement) {
        var pos = this.positionElement.offset().left + this.positionElement.width() / 2;
        this.setPosition(pos);
      }
    }

    /*
     * Set element for auto-positioning arrow
     */
  }, {
    key: "setPositionToElement",
    value: function setPositionToElement(element) {
      this.positionElement = element;
      this.update();
    }

    /*
     * Center arrow
     */
  }, {
    key: "center",
    value: function center() {
      var posCenter = this.container.outerWidth() / 2;
      this.setPosition(posCenter);
    }
  }]);
}();